<template>
  <a class="youtube" href="/login?provider=youtube">
    <div class="img"><img src="../../assets/img/youtube-logo.png"></div>
    <div class="prompt">{{$t('index.login_prompt_youtube')}}</div>
  </a>
</template>

<script>
export default {
  props: {
    href: String
  }
};
</script>

<style lang="scss">
a.youtube {
  display: inline-flex;
  flex-direction: row;
  align-items: stretch;
  background-color: #ff0000;
  border-radius: 3px;
  box-shadow: 1px 1px #00000020;
  .img {
    margin: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 18pt;
      margin: 8px 10px;
    }
  }
  .prompt {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8pt;
    white-space: nowrap;
  }
}
</style>
